import Loader from '../../modules/components/Loader';

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader/Loader.js